<template>
  <v-card v-if="hasAppsImplemented" width="100%" flat color="transparent">
    <!-- For breakpoints of md and up -->
    <v-row class="hidden-sm-and-down my-0" justify="center" align="center">
      <v-col cols="11">
        <v-card color="primary" elevation="1" tile>
          <v-card-text class="px-3 py-2">
            <h3
              class="primary-font-color homepageSubTitle text-h6 font-weight-bold text-break"
            >
              {{ $translate('DOWNLOAD_APP') }}
            </h3>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- For breakpoints of sm and down -->
    <v-card-title class="hidden-md-and-up pa-0">
      <h2 class="text-break homepageTitle">
        {{ $translate('DOWNLOAD_APP') }}
      </h2>
    </v-card-title>

    <v-card-text class="pa-0 px-md-4 mt-1">
      <v-row class="ma-0">
        <div class="text--darken-3 grey--text">{{ downloadText }}</div>

        <v-col align="center" class="pb-0 px-0" cols="12">
          <a
            :href="playStoreUrl"
            v-if="currentOS === 'Android' || currentOS === 'unknown'"
          >
            <v-img
              :src="require('@/assets/Download_on_the_Play_Store.png')"
              :width="downloadPictureWidth"
              alt="Get it on Google Play"
              class="mb-2"
            />
          </a>

          <a
            :href="appStoreUrl"
            v-if="currentOS === 'iOS' || currentOS === 'unknown'"
          >
            <v-img
              :src="require('@/assets/Download_on_the_App_Store.png')"
              :width="downloadPictureWidth"
              alt="Download on the App Store"
            />
          </a>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import appDownloadMixin from '@/mixins/appDownload';

export default {
  name: 'AppDownloadButtonsClassic',
  mixins: [appDownloadMixin],
};
</script>
